export default function Logo({ size = "md", onDark = false }) {
  return (
    <img
      src={onDark ? "/images/brand-logo.png" : "/images/brand-logo-ink.png"}
      alt="The Studio 31 — Interior Design & Architecture"
      className={`${size === "lg" ? "h-16 sm:h-20" : "h-12"} w-auto select-none`}
      draggable={false}
    />
  );
}
